export const testVideo = {
  id: "video123",
  title: "Perfect Margherita Pizza From Scratch",
  youtubeUrl: "https://www.youtube.com/watch?v=1-SJGQ2HLp8",
  embedUrl: "https://www.youtube.com/embed/1-SJGQ2HLp8",
  thumbnailUrl: "https://img.youtube.com/vi/1-SJGQ2HLp8/maxresdefault.jpg",
  author: "Chef John Smith",
  dateCreated: "2023-11-15T08:00:00.000Z",
  lastModified: "2023-11-15T08:00:00.000Z",
  description: `In this comprehensive guide, I'll show you how to make an authentic Margherita pizza from scratch. We'll cover everything from making the perfect pizza dough to selecting the best ingredients and achieving that perfect crispy crust.

This video includes:
- Making pizza dough from scratch
- Proper kneading techniques
- Sauce preparation
- Best cheese selection
- Baking tips and tricks
- Professional plating presentation`,
  transcription: `Hello everyone, welcome back to my channel. Today we're making the perfect Margherita pizza from scratch.

[00:00:15] First, let's start with our dough. You'll need:
- 3 cups of high-quality flour
- 1 teaspoon of salt
- 1 teaspoon of sugar
- 2 1/4 teaspoons of active dry yeast
- 1 cup of warm water
- 2 tablespoons of olive oil

[00:01:30] Begin by mixing your dry ingredients...

[00:15:45] And there you have it - the perfect Margherita pizza. Don't forget to like and subscribe for more recipes!`,
  relatedRecipes: [
    {
      id: "recipe123",
      title: "Classic Margherita Pizza",
      image: "https://images.unsplash.com/photo-1604068549290-dea0e4a305ca",
    },
    {
      id: "recipe124",
      title: "Pizza Dough Base",
      image: "https://images.unsplash.com/photo-1585238342024-78d387f4a707",
    }
  ],
  metadata: {
    duration: "18:24",
    views: 15234,
    likes: 1842,
    category: "Cooking",
    tags: ["Pizza", "Italian", "Baking", "Main Course"],
  },
  analytics: {
    totalViews: 15234,
    averageViewDuration: "15:45",
    engagement: 0.85,
    demographics: {
      age: {
        "18-24": 0.2,
        "25-34": 0.4,
        "35-44": 0.25,
        "45+": 0.15
      },
      gender: {
        male: 0.45,
        female: 0.55
      }
    },
    viewsByCountry: {
      "United States": 0.4,
      "United Kingdom": 0.15,
      "Canada": 0.1,
      "Other": 0.35
    }
  },
  comments: [
    {
      id: "comment123",
      user: "PizzaLover42",
      text: "Great tutorial! My pizza came out perfect!",
      date: "2023-11-14T10:30:00.000Z",
      likes: 45
    },
    {
      id: "comment124",
      user: "HomeChef88",
      text: "Could you clarify the oven temperature for a conventional oven?",
      date: "2023-11-13T15:45:00.000Z",
      likes: 12
    }
  ]
};

// Sample related videos
export const relatedVideos = [
  {
    id: "video124",
    title: "Perfect Pizza Sauce Recipe",
    thumbnailUrl: "https://img.youtube.com/vi/whnvQBhXh3A/maxresdefault.jpg",
    duration: "12:34",
    views: 8562
  },
  {
    id: "video125",
    title: "Pizza Dough Kneading Techniques",
    thumbnailUrl: "https://img.youtube.com/vi/8Q_9h6VKm9c/maxresdefault.jpg",
    duration: "15:20",
    views: 12453
  }
];

// Available categories for videos
export const videoCategories = [
  "Main Course",
  "Appetizers",
  "Desserts",
  "Baking",
  "Grilling",
  "Quick Meals",
  "Vegetarian",
  "Vegan",
  "Breakfast",
  "Lunch",
  "Dinner",
  "Snacks",
  "Drinks",
  "Tips & Techniques"
];

// Sample user data for video creator
export const videoCreator = {
  id: "user123",
  name: "Chef John Smith",
  avatar: "https://randomuser.me/api/portraits/men/1.jpg",
  subscribers: 125000,
  totalViews: 1500000,
  channelUrl: "https://youtube.com/@chefjohnsmith",
  socialMedia: {
    instagram: "@chefjohnsmith",
    twitter: "@chefjohnsmith",
    website: "https://chefjohnsmith.com"
  }
};